import { render, staticRenderFns } from "./column-name-input.vue?vue&type=template&id=1bc1f1e1&"
import script from "./column-name-input.vue?vue&type=script&lang=js&"
export * from "./column-name-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports